// extracted by mini-css-extract-plugin
export default {"Container":"Error_Container__+ycik","Title":"Error_Title__AQWT4","Message":"Error_Message__cVulG"};